export enum InputFindType {
    BusinessAccount = 1,
    Lead = 2,
    Contact = 3,
    ClientAccount = 4,
    User = 5, // Can use for various users eg buildingConsultants
    Vendor = 6,
    SellingAgent = 7
}
